import React from 'react';
import './index.scss';
import { Routes } from '@routes/Routes';
import { AppConfig } from '@config/AppConfig';
import { getEnvConfigs } from '@config/config.services';
import Helmet from 'react-helmet';
import { AzureAdAuth, ModalLoader } from '@gcl/react-core';
import '@gcl/react-core/dist/main.css';
import { createRoot } from 'react-dom/client';
import '@gcl/react-core/dist/themes.scss';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { AppErrorBoundary } from '@common/error/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';

interface IIndexProps {}

const Index: React.FC<IIndexProps> = ({}) => {
  const envConfigs = getEnvConfigs();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: envConfigs.env !== 'LOCAL',
        refetchOnMount: envConfigs.env !== 'LOCAL',
        refetchOnReconnect: envConfigs.env !== 'LOCAL',
        retry: false,
      },
    },
  });

  const apiOrigin = new URL(envConfigs.apiBaseUrl || '')?.origin;

  return (
    <ErrorBoundary FallbackComponent={AppErrorBoundary}>
      <AppConfig>
        <QueryClientProvider client={queryClient}>
          <React.Suspense fallback={<ModalLoader />}>
            <AzureAdAuth
              configs={{
                clientId: envConfigs.clientId as string,
                authority: envConfigs.authority as string,
                redirectUrl: envConfigs.redirectUrl as string,
              }}
            >
              <Helmet>
                <meta charSet="utf-8" />
                <title>GEMS</title>
              </Helmet>
              <Helmet>
                <meta
                  httpEquiv="Content-Security-Policy"
                  content={`default-src 'self'; style-src 'self' 'unsafe-inline'; img-src 'self' data: https://logo.gammonconstruction.com; connect-src https://login.microsoftonline.com https://graph.microsoft.com ${apiOrigin} 'self'; child-src https://login.microsoftonline.com 'self'; frame-ancestors 'none'; media-src 'self' data:; frame-src https://login.microsoftonline.com https://www.youtube.com 'self';`}
                />
              </Helmet>
              <Routes />
            </AzureAdAuth>
          </React.Suspense>
        </QueryClientProvider>
      </AppConfig>
    </ErrorBoundary>
  );
};

const rootElement = document.getElementById('root');
const root = createRoot(rootElement as HTMLElement);
root.render(<Index />);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
